<div [ngClass]=" marginTop ? 'download-all-button-margin-top' : ''"></div>
<div style="text-align: end;" *ngIf="shouldShowDocumentLinks">
  <a
    class="btn btn--link btn--link--secondary btn--link--secondary--icon p-0 u-mb10"
    (click)="downloadAllFiles()"
  >
    <div class="loader-container" *ngIf=" downloadingAllDocumentsPercent > 0 && downloadingAllDocumentsPercent < 100">
      <app-loader></app-loader>
    </div>
    <img src="assets/img/down_g.png" class="correct-download-img-position" alt="">
      Descargar todos los archivos
    <span style="opacity: 0;">100%</span>
    <div
      [ngClass]="{'opacity-zero' : !(downloadingAllDocumentsPercent > 0)}"
      style="position: absolute;top: 2px;right: 13px; width: 39px;text-align: center;"
    >
      {{downloadingAllDocumentsPercent}}%
    </div>
  </a>
</div>

<div class="table table--documents u-mb20 u-bt" style="margin-top: 0 !important">
  <div class="thead thead--border">
    <div class="tr">
      <div class="th column-document-name-max-width"><b>Requisitos</b></div>
      <div *ngIf="shouldShowDocumentLinks" class="th"><b>Documento</b></div>
      <div class="th column-document-date-max-width"><b>Fecha de vigencia</b></div>
      <div *ngIf="!shouldShowDocumentLinks" class="th column-document-date-max-width">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
      <div class="th column-document-date-max-width">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
    </div>
  </div>
  <form class="tbody">
    <div class="tr" *ngFor="let item of documents; index as i;">
      <div class="td td--name td--pt column-document-name-max-width ">
        <p>{{item.description}}<app-tooltip [text]="item.tooltip ? getTextOfEntity(item?.tooltip) : ''"></app-tooltip>
        </p>
        <h6 class="txt txt--paragraph">{{getTextOfEntity(item.hint)}}</h6>
      </div>
      <div *ngIf="shouldShowDocumentLinks && (!editableDocuments ? true : !editingEntrys[i])" class="td td--name td--pt ">
        <app-download-document
          [driverMdmId]="this.driverMdmid"
          [requirementId]="this.requirementId"
          [assetId]="this.assetId"
          [documentId]="item.id"
          [documentName]="item.description"
        >
        </app-download-document>
      </div>
      <div class="td td--pt correct-padding td--date " *ngIf="!editingEntrys[i]">
        <span class="height-match-calendar">
          <p *ngIf="item.dateEmit">Emisión el {{item.dateEmit | date: 'dd/MM/yyyy'}}</p>
          <p *ngIf="!item.dateEmit && item.dateFrom && item.dateUntil">Del {{item.dateFrom | date: 'dd/MM/yyyy'}}
            al {{item.dateUntil | date: 'dd/MM/yyyy'}}
          </p>
          <p *ngIf="!item.dateEmit && item.dateFrom && !item.dateUntil">Del {{item.dateFrom | date: 'dd/MM/yyyy'}}
            a Indefinido
          </p>
        </span>
        <div class="form calendar-placeholder">
          <label for="" class="label">
            Emisión
          </label>
          <app-calendar>
          </app-calendar>
          <h6 class="form__info global-unmount" [ngClass]="{'thiner-hint': !editableDocuments, 'invisible-hint': editableDocuments}">
            *Formato PDF. Max. 10 MB
          </h6>
        </div>
      </div>

      <!-- Form controls -->
      <ng-container *ngIf="editingEntrys[i]">
        <ng-container [formGroup]="formGroup" *ngFor="let formGroup of [getformGroupByRowIndex(i)]">
          <div class="td td--pt correct-padding td--calendar" *ngIf="editableDocuments">
            <div class="form">
              <app-attach-document
                [showErrors]="true"
                [requiredDocumentId]="item.documentRequiredTypeId"
                [placeholder]="asFormControl(formGroup.controls.file).value.fileName"
                [controlForm]="asFormControl(formGroup.controls.file)"
                [requirementId]="requirementId"
                [assetId]="assetId"
                [driverMdmid]="driverMdmid"
              >
              </app-attach-document>
            </div>
          </div>
          <div style="margin-top: 10px;" class="td td--pt correct-padding td--date column-document-date-max-width" *ngIf="item.dateEmit">
            <div class="form">
              <label for="" class="label">
                Emisión
              </label>
              <app-calendar colorOnMovileView="WHITE" [defaultDate]="item.dateEmit" [controlForm]="asFormControl(formGroup.controls.dateEmit)">
              </app-calendar>
              <h6 class="form__info global-unmount" [ngClass]="{'thiner-hint': !editableDocuments, 'invisible-hint': editableDocuments}">
                *Formato PDF. Max. 10 MB
              </h6>
            </div>
          </div>
          <div style="margin-top: 10px;" class="td td--pt correct-padding td--date column-document-date-max-width" *ngIf="item.dateEmit">
            <!-- Lo dibuja pero no es accesible ni lo muestra -->
            <div class="form" [ngClass]="{'hide': item.dateEmit}">
              <app-calendar></app-calendar>
              <h6 class="form__info global-unmount" [ngClass]="{'thiner-hint': !editableDocuments, 'invisible-hint': editableDocuments}">
                *Formato PDF. Max. 10 MB
              </h6>
            </div>
          </div>
          <div style="margin-top: 10px;" class="td td--pt correct-padding td--date column-document-date-max-width" *ngIf="!item.dateEmit">
            <div class="form">
              <label for="" class="label">
                Desde
              </label>
              <app-calendar colorOnMovileView="WHITE"  [defaultDate]="item.dateFrom" [controlForm]="asFormControl(formGroup.controls.dateFrom)">
              </app-calendar>
              <app-error-message [text]="documentDateFromError(i)"></app-error-message>
              <h6 class="form__info global-unmount" [ngClass]="{'thiner-hint': !editableDocuments, 'invisible-hint': editableDocuments}">
                *Formato PDF. Max. 10 MB
              </h6>
            </div>

          </div>
          <div style="margin-top: 10px;" class="td td--pt correct-padding td--date column-document-date-max-width" *ngIf="!item.dateEmit">
            <div class="form">
              <label for="" class="label">
                Hasta
              </label>
              <app-calendar colorOnMovileView="WHITE"  [defaultDate]="item.dateUntil" [controlForm]="asFormControl(formGroup.controls.dateUntil)" [canBeUndefined]="true">
              </app-calendar>
              <app-error-message [text]="documentDateRangeError(i)"></app-error-message>
              <h6 class="form__info global-unmount" [ngClass]="{'thiner-hint': !editableDocuments, 'invisible-hint': editableDocuments}">
                *Formato PDF. Max. 10 MB
              </h6>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <!-- Form controls -->

      <div *ngIf="!shouldShowDocumentLinks" class="td td--name td--pt ">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </p>
      </div>
      <div class="td td--name td--pt " *ngIf="!editingEntrys[i]">
        <a *ngIf="shouldEditEffectiveDate"
          class="btn btn--link btn--link--secondary btn--link--secondary--icon btn--link--secondary--color p-0 js-load"
          (click)="onEditAnEntry(i,item.id)"> <img src="assets/img/lapiz.png" alt="">Editar</a>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </p>
      </div>
    </div>
  </form>
</div>
